import React from 'react';
import { Box, Divider } from '@mui/material';
import StopProcess from './components/StopProcess';
import Permissions from './components/Permissions';
import LabelsConfig from './components/Labels';
import Exports from './components/Exports';
import States from './components/States';

export default function Configuration() {
  return (
    <Box>
      <Exports />
      <Box py={2}>
        <Divider />
      </Box>
      <StopProcess />
      <Box py={2}>
        <Divider />
      </Box>
      <LabelsConfig />
      <Box py={2}>
        <Divider />
      </Box>
      <States />
      <Box py={2}>
        <Divider />
      </Box>
      <Permissions />
      <Box py={2}>
        <Divider />
      </Box>
    </Box>
  );
}
